import { IItem } from '@checkout/items';
import { RootState } from '@checkout/state';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import messages from '../../../i18n/base-en';
import { addToCart, removeLineItemRequest } from '../../../reducers/checkout';
import { InputBox } from '../../presentational';
import { selectItemById } from './../../../utils/utils';

interface IOwnProps {
  productId: string;
  items: IItem[];
}

interface IConnectetDispatchProps {
  addToCart: typeof addToCart;
  removeLineItemRequest: typeof removeLineItemRequest;
}

interface IConnectedProps {}

type Props = IOwnProps & IConnectedProps & IConnectetDispatchProps & InjectedIntlProps;

interface IOwnState {
  isActive: boolean;
}

class GiftWrap extends React.Component<Props, IOwnState> {

  state: IOwnState = {
    isActive: selectItemById(this.props.items, this.props.productId) !== undefined
  };

  toggleActive = () => {
    const { addToCart: addGiftWrapProduct, removeLineItemRequest: removeGiftWrapProduct, items, productId: itemId } = this.props;
    const item = selectItemById(items, itemId);

    this.setState({
      isActive: !this.state.isActive,
    }, () => { // Fallback function
      if (item !== undefined) {
        removeGiftWrapProduct({ line: item.line, quantity: 1 });
      } else {
        addGiftWrapProduct({ itemId, quantity: 1 });
      }
    });
  }

  render() {
    const { intl } = this.props;
    const { isActive } = this.state;
    const { formatMessage } = intl;

    return (
      <InputBox
        id="voucher_switch_button"
        name="voucher_switch_button"
        type="checkbox"
        checked={isActive}
        value={isActive}
        onChange={this.toggleActive}
        variant="toggle"
        label={formatMessage(messages.gift_wrap_switch_button_label)}
      />
    );
  }
}

export default compose<React.ComponentClass<IOwnProps>>(
  injectIntl,
  connect<IConnectedProps, IConnectetDispatchProps>(
    (state: RootState) => ({}),
    {
      addToCart,
      removeLineItemRequest,
    }
  ),
)(GiftWrap);
